<template>
  <a-card>
    <h2>Write CSS</h2>
    <div class="button-wrap">
      <p>
        You can open up the editor and write css file directly here.
      </p>
      <a-button
        type="primary"
        icon="edit"
        class="button"
        @click="isOpen = true"
      >
        Open Editor
      </a-button>
    </div>
    <div class="ace-wrapper"
      v-if="isOpen"
    >
      <AceEditor
        @init="editorInit"
        v-model="localCssStr"
        lang="html"
        theme="monokai"
        width="100%"
        height="235px"
        :options="{
          enableBasicAutocompletion: true,
          enableLiveAutocompletion: true,
          fontSize: 14,
          highlightActiveLine: true,
          enableSnippets: true,
          showLineNumbers: true,
          tabSize: 2,
          showPrintMargin: false,
          showGutter: true,
        }"
        :commands="[
          {
            name: 'save',
            bindKey: { win: 'Ctrl-s', mac: 'Command-s' },
            exec: emitWriteFile,
            readOnly: true,
          },
        ]"
      />
      <div class="confirm">
        <a-button
          type="primary"
          icon="edit"
          class="button"
          style="margin-top: 20px;"
          @click="emitWriteFile"
        >
          Submit File
        </a-button>
      </div>
    </div>
  </a-card>
</template>

<script>
import AceEditor from "vuejs-ace-editor";
export default {
  components: {
    AceEditor,
  },
  props: {
    cssStr: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      localCssStr: null,
      isOpen: false,
    };
  },
  watch: {
    cssStr: {
      handler () {
        this.localCssStr = this.cssStr;
      },
    }
  },
  methods: {
    editorInit() {
      require("brace/ext/language_tools"); //language extension prerequsite...
      require("brace/mode/html");
      require("brace/mode/javascript"); //language
      require("brace/mode/less");
      require("brace/theme/monokai");
      require("brace/snippets/javascript"); //snippet
    },
    emitWriteFile () {
      this.$emit('file-upload', this.localCssStr);
    },
  },
};
</script>

<style lang="scss" scoped>
.ace-wrapper {
  margin-top: 20px;
}

.button {
  display: flex;
  align-items: center;
  padding: 8px 16px;

  width: 141px;
  height: 40px;

  background: #2295D6;
  border-radius: 2px;
  color: #FFF;
  &.cancel {
    width: auto;
    justify-content: center;
    background: #FFF;
    color: #001529;  
  }
}
</style>